// Material-ui
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link, useRouteLoaderData } from "react-router-dom";

// Project imports
import PreviewLabel from "components/PreviewLabel";
import useLayoutState from "hooks/useLayoutState";
import getCurrentUser from "hooks/getCurrentUser";
import LogOutButton from "./LogOutButton";

export default function Header() {
  const theme = useTheme();
  const { isSidebarDrawerOpen, toggleIsSidebarDrawerOpen } = useLayoutState();
  const loggedInUser = getCurrentUser();
  const displayName = `${loggedInUser?.first_name} ${loggedInUser?.last_name}`;

  return (
    <AppBar
      enableColorOnDark
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: "primary.main",
        color: "primary.light",
        transition: isSidebarDrawerOpen
          ? theme.transitions.create("width")
          : "none",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          flexFlow: { xs: "column", md: "row" },
          py: "12px",
        }}
      >
        {/* logo & toggler button */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
              width: "auto",
              marginBottom: 2,
            },
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => toggleIsSidebarDrawerOpen()}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 0.5 }}>
                <Typography
                  variant="h2"
                  color="inherit"
                  sx={{ fontWeight: 600 }}
                >
                  PAD
                </Typography>
                {/* <PreviewLabel /> */}
              </Box>

              <Typography variant="h5" color="inherit" sx={{ fontWeight: 500 }}>
                From Community Tech Alliance
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: "flex", alignItems: "center", color: "inherit" }}>
          <Typography color="inherit" sx={{ mr: 1 }}>
            Logged in as {displayName}
          </Typography>
          {loggedInUser?.is_superuser && (
            <>
              <AdminPanelSettingsIcon />
              <Typography
                variant="h5"
                color="inherit"
                sx={{ fontWeight: 600, mr: 2 }}
              >
                Superuser
              </Typography>
            </>
          )}
          {(loggedInUser?.is_staff || loggedInUser?.is_superuser) && (
            <>
              <Button
                variant="contained"
                color="inherit"
                component={Link}
                to="/admin/sync-schedule"
                sx={{
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "primary.main",
                  backgroundColor: "primary.light",
                  "&:hover": {
                    backgroundColor: "grey.300",
                  },
                }}
              >
                Admin Hub
              </Button>
              <Button
                variant="contained"
                color="inherit"
                // Override the default Link behavior, as we're leaving the SPA
                onClick={() => (window.location = "/control/")}
                sx={{
                  mr: 2,
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "primary.main",
                  backgroundColor: "primary.light",
                  "&:hover": {
                    backgroundColor: "grey.300",
                  },
                }}
              >
                Control
              </Button>
            </>
          )}
          <LogOutButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
